import { Link, useSearchParams } from 'react-router-dom';
import EnquiryComp from '../forms/EnquiryComp';
import './FooterComp.css';
import { API_URL, CAMPAIGN_ID_CONTACT, CDN_URL } from '../../../../config/config';
import { useEffect } from 'react';
import axios from 'axios';

const FooterComp = () => {

    const [searchParams] = useSearchParams();
    const cId = searchParams.get('c_id') || null;
    const campaignId = cId && cId.trim() !== "" ? cId : CAMPAIGN_ID_CONTACT;
    
    const templateId = searchParams.get('template_id') || null;
    const batchId = searchParams.get('batch_id') || null;
    const emailId = searchParams.get('email_id') || null;

    useEffect(() => {

        if(campaignId !== "" && campaignId !== null && templateId !== "" && templateId !== null && batchId !== "" && batchId !== null && emailId !== "" && emailId !== null) {
            (async() => {
                try {

                    const ipResponse = await fetch('https://api.ipify.org?format=json');
                    const ipData = await ipResponse.json();
                    const clientIp = ipData.ip;

                    const formData = new FormData();
                    formData.append("campaign_id", campaignId);
                    formData.append("template_id", templateId);
                    formData.append("batch_id", batchId);
                    formData.append("email_id", emailId);
                    formData.append("ip_address", clientIp);

                    const response = await axios.post(
                        `${API_URL}vnext/campaign/marketing/emails/track/visits/`,
                        formData,
                        { headers: { "Content-Type": "multipart/form-data" }}
                    );

                    if (response.status >= 200 && response.status <= 299 && response.data.status === 200) {
                        console.log("Campaign captured successfully!");
                    } else {
                        console.warn("Failed to capture campaign, please check the response.", response);
                    }

                } catch (error) {
                    console.error("Failed to capture campaign, please check the response.", error.message);
                }
            })();
        }

    }, [campaignId, templateId, batchId, emailId]);

    
    return (
        <>
            <footer className='footer border'>
                <nav className="footer-social bg-light border-bottom">
                    <div className='container'>
                        <ul className='nav d-flex align-items-center justify-content-center'>
                            <li className="nav-item px-1 py-3 text-center border-end">
                                <Link to="https://www.facebook.com/vnextbyvisaka" className='transition-effect text-decoration-none' target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" /></svg>
                                </Link>
                            </li>
                            <li className="nav-item px-1 py-3 text-center border-end">
                                <Link to="https://twitter.com/vnext_visaka" className='transition-effect text-decoration-none' target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M459.4 151.7c.3 4.5 .3 9.1 .3 13.6 0 138.7-105.6 298.6-298.6 298.6-59.5 0-114.7-17.2-161.1-47.1 8.4 1 16.6 1.3 25.3 1.3 49.1 0 94.2-16.6 130.3-44.8-46.1-1-84.8-31.2-98.1-72.8 6.5 1 13 1.6 19.8 1.6 9.4 0 18.8-1.3 27.6-3.6-48.1-9.7-84.1-52-84.1-103v-1.3c14 7.8 30.2 12.7 47.4 13.3-28.3-18.8-46.8-51-46.8-87.4 0-19.5 5.2-37.4 14.3-53 51.7 63.7 129.3 105.3 216.4 109.8-1.6-7.8-2.6-15.9-2.6-24 0-57.8 46.8-104.9 104.9-104.9 30.2 0 57.5 12.7 76.7 33.1 23.7-4.5 46.5-13.3 66.6-25.3-7.8 24.4-24.4 44.8-46.1 57.8 21.1-2.3 41.6-8.1 60.4-16.2-14.3 20.8-32.2 39.3-52.6 54.3z" /></svg>
                                </Link>
                            </li>
                            <li className="nav-item px-1 py-3 text-center border-end">
                                <Link to="https://www.youtube.com/user/vnextbyvisaka" className='transition-effect text-decoration-none' target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" /></svg>
                                </Link>
                            </li>
                            <li className="nav-item px-1 py-3 text-center border-end">
                                <Link to="https://www.instagram.com/vnextbyvisaka/" className='transition-effect text-decoration-none' target='_blank'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" /></svg>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div className='footer-menu py-3 p-md-4 shadow-sm'>
                    <div className='container'>
                        <div className='d-flex align-items-center justify-content-evenly flex-column flex-lg-row'>
                            <div className='logo p-0 p-lg-2 d-flex mb-3 mb-lg-0'>
                                <img width="120" height="30" src={CDN_URL+'visaka/vnext/website/assets/images/logo.webp'} className='p-3 p-lg-0' alt='Vnext Logo' />
                                <img width="120" height="30" src={CDN_URL+'visaka/vnext/website/assets/images/visakaLogo.webp'} className='d-lg-none p-3' alt='Visaka Logo' />
                            </div>
                            <div className='menu'>
                                <nav className='footer-menu-nav d-flex flex-column flex-sm-row'>
                                    <ul className='nav d-none d-md-flex flex-column align-items-center align-items-lg-start px-3 px-md-4 px-xl-5'>
                                        <li className="nav-item p-1">
                                            <Link to="/blogs/1" className='transition-effect text-decoration-none transition-effect'>Blog</Link>
                                        </li>
                                        <li className="nav-item p-1">
                                            <Link to="/products" className='transition-effect text-decoration-none transition-effect'>Products</Link>
                                        </li>
                                        <li className="nav-item p-1">
                                            <Link to="/contact" className='transition-effect text-decoration-none transition-effect'>Contact us</Link>
                                        </li>
                                        <li className="nav-item p-1">
                                            <Link to="/testimonials" className='transition-effect text-decoration-none transition-effect'>Testimonials</Link>
                                        </li>
                                    </ul>
                                    <ul className='nav d-none d-sm-flex flex-column align-items-center align-items-lg-start px-3 px-md-4 px-xl-5'>
                                        <li className="nav-item p-1">
                                            <Link to="/videos" className='transition-effect text-decoration-none transition-effect'>Media</Link>
                                        </li>
                                        <li className="nav-item p-1">
                                            <Link to="/clients" className='transition-effect text-decoration-none transition-effect'>Clients</Link>
                                        </li>
                                        <li className="nav-item p-1">
                                            <Link to="/sitemap" className='transition-effect text-decoration-none transition-effect'>Sitemap</Link>
                                        </li>
                                        <li className="nav-item p-1">
                                            <Link to="/download-brochure" className='transition-effect text-decoration-none transition-effect'>Download Brochure</Link>
                                        </li>
                                    </ul>
                                    <ul className='nav d-flex flex-column align-items-center align-items-lg-start px-3 px-md-4 px-xl-5'>
                                        <li className="nav-item p-1">
                                            <Link to="/disclaimer" className='transition-effect text-decoration-none transition-effect'>Disclaimer</Link>
                                        </li>
                                        <li className="nav-item p-1">
                                            <Link to="/cookie-policy" className='transition-effect text-decoration-none transition-effect'>Cookie policy</Link>
                                        </li>
                                        <li className="nav-item p-1">
                                            <Link to="/privacy-policy" className='transition-effect text-decoration-none transition-effect'>Privacy policy</Link>
                                        </li>
                                        <li className="nav-item p-1">
                                            <Link to="/term-conditions" className='transition-effect text-decoration-none transition-effect'>Terms & Conditions</Link>
                                        </li>
                                      
                                    </ul>
                                </nav>
                            </div>
                            <div className='logo p-2 d-none d-lg-block'>
                                <img src={CDN_URL+'visaka/vnext/website/assets/images/visakaLogo.webp'} alt='Visaka Logo' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='footer-copyrights py-3'>
                    <div className='container'>
                        <div className='footer-copyrights-content text-center'>
                            <p className='mb-0'>All information is subject to specific conditions.</p>
                            <p className='mb-0'>&#169; 2024 Vnext. All rights reserved</p>
                        </div>
                    </div>
                </div>
            </footer>
            <EnquiryComp />
        </>
    );
}
export default FooterComp;